import "./App.css";
import "bootstrap-4-react";
import "react-bootstrap";
import "react-icons/fa";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastProvider } from "./context/ToastContext";
import { SettingsProvider } from "./context/SettingsContext";

import { AuthProvider } from "./components/AuthContext";

import ProjectsLayout          from "./components/ProjectsLayout";
import GoogleMapWithMarkers    from "./components/GoogleMapWithMarkers";
import PaymentSuccessPage      from "./components/PaymentSuccessPage";
import ApartmentViewer         from "./components/ApartmentViewer";
import FloorPlanPage           from "./components/FloorPlanPage";
import PanoramaViewer          from "./components/PanoramaViewer";
import UnitPage                from "./components/UnitPage";
import RoomPanoramaPage        from "./components/RoomPanoramaPage";
import GalleryPanoramaPage     from "./components/GalleryPanoramaPage";
import PaymentPage             from "./components/PaymentPage";
import UserDashboard           from "./components/UserDashboard";
import ChatBubble              from "./components/ChatBubble";

const MAPS_LIBRARIES = ["places"];

function App() {
  // ── No more fetch here — SettingsProvider handles it ──
  return (
    <SettingsProvider>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={MAPS_LIBRARIES}
      >
        <BrowserRouter basename="/book-an-apartment">
          <Provider store={store}>
            <ToastProvider>
              <Routes>
                <Route path="/"                                                   element={<ProjectsLayout />} />
                <Route path="/location/:projectId"                                element={<GoogleMapWithMarkers />} />                
                <Route path="/payment-success"                                    element={<PaymentSuccessPage />} />             
                <Route path="/apartment-view/:masterPlanId"                      element={<ApartmentViewer />} />
                <Route path="/floor/:floorId"                                     element={<FloorPlanPage />} />
                <Route path="/unit/:plotId"                                       element={<UnitPage />} />
                <Route path="/unit/:plotId/room/:roomId"                         element={<RoomPanoramaPage />} />
                <Route path="/floor/:floorId/room/:roomId"                       element={<PanoramaViewer />} />
                <Route path="/unit/:plotId/gallery/:index"                       element={<GalleryPanoramaPage />} />
                <Route path="/payment/:bookingId"                                 element={<PaymentPage />} />
                <Route path="/dashboard"                                          element={<UserDashboard />} />
              </Routes>
              <ChatBubble />
            </ToastProvider>
          </Provider>
        </BrowserRouter>
      </LoadScript>
    </SettingsProvider>
  );
}

export default App;
